import React from 'react';

import { Nav } from '../components/Nav';
import { Hero } from './parts/Hero';
import { About } from './parts/About';
import { Offer } from './parts/Offer';
import { CTA } from './parts/CTA';
import { Footer } from '../components/Footer';
import { MetaTagsComponent } from '../components/MetaTags';

const Home = () => {
  return (
    <>
      <MetaTagsComponent lang="en" />
      <Nav />
      <Hero />
      <About />
      <Offer />
      <CTA />
      <Footer />
    </>
  );
};

export { Home };
